function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/* global moment */

(function (window) {
  'use strict';

  angular.module('wsLrs.controllers').service('ExplorerService', [function () {
    var _card = null;
    return {
      getCard: function getCard() {
        return angular.extend({}, _card);
      },
      setCard: function setCard(card) {
        _card = card;
      }
    };
  }]).factory('ExplorerUtils', ['Activities', 'Verbs', 'People', 'Groups', '$q', '$http', 'Api', 'TinCanJS', 'GroupTypes', 'Utils', 'FilterPermissionSvc', 'FilterRegistry', function (Activities, Verbs, People, Groups, $q, $http, Api, TinCanJS, GroupTypes, Utils, FilterPermissionSvc, FilterRegistry) {
    function getDateWithTimezone(customDate) {
      var hasTimezoneRegex = /([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)$/;
      var noTimezone = customDate && !hasTimezoneRegex.test(customDate);
      // Warning: new Date(date + "Z") does NOT return the same value as new Date(date)
      // We should write tests around this and ensure it's being accounted for wherever these values are used
      // This would also reduce some complexity within the toDateOnSelect function inside picker.js
      return noTimezone ? new Date(customDate + "Z") : new Date(customDate);
    }
    var _isVisible = false;
    var self = {
      emptyDateFilter: {
        dateType: 'none',
        trailingAmount: 1,
        trailingType: 'days',
        customDateFrom: null,
        customDateTo: null
      },
      populateSimpleModeScope: function populateSimpleModeScope(filter, cfg) {
        filter = angular.copy(filter);
        if (!filter) {
          return;
        }
        var activityPickerConfig = cfg.activityPickerConfig,
          verbPickerConfig = cfg.verbPickerConfig,
          peoplePickerConfig = cfg.peoplePickerConfig,
          datePickerConfig = cfg.datePickerConfig,
          immutable = cfg.immutable || false,
          excludedActivitiesFilter,
          excludedPeopleOrGroupsFilter,
          excludedVerbsFilter,
          customFilterPickerConfig = cfg.customFilterPickerConfig;
        cfg.scope = cfg.scope || {};
        if (filter.not && filter.not.or) {
          excludedActivitiesFilter = _.find(filter.not.or, function (f) {
            return f.activityIds || f.activityTypes;
          }), excludedPeopleOrGroupsFilter = _.find(filter.not.or, function (f) {
            return f.personIds || f.personCustomIds || f.groupIds || f.groupCustomIds || f.groupTypeNames;
          }), excludedVerbsFilter = _.find(filter.not.or, function (f) {
            return f.verbIds;
          });
        }
        activityPickerConfig.selectedActivities = [];
        activityPickerConfig.excludedActivities = [];
        if (filter.activityIds || excludedActivitiesFilter) {
          var activityIds = filter.activityIds ? filter.activityIds.ids : [];
          if (excludedActivitiesFilter && excludedActivitiesFilter.activityIds) {
            activityIds = activityIds.concat(excludedActivitiesFilter.activityIds.ids);
          }
          Activities.multiGetByActivityId(activityIds).then(function (results) {
            if (filter.activityIds) {
              _.each(filter.activityIds.ids, function (value) {
                var activity = _.findWhere(results.results, {
                  activityId: value
                });
                if (activity) {
                  activityPickerConfig.addActivity(activity, immutable);
                } else {
                  activityPickerConfig.addActivity({
                    activityId: value,
                    name: value
                  }, immutable);
                }
              });
            }
            if (excludedActivitiesFilter && excludedActivitiesFilter.activityIds) {
              _.each(excludedActivitiesFilter.activityIds.ids, function (value) {
                var activity = _.findWhere(results.results, {
                  activityId: value
                });
                if (activity) {
                  activityPickerConfig.excludeActivity(activity, immutable);
                } else {
                  activityPickerConfig.excludeActivity({
                    activityId: value,
                    name: value
                  }, immutable);
                }
              });
            }
          });
          activityPickerConfig.includeRelatedActivities = filter.includeRelatedActivities;
        }
        if (filter.activityTypes) {
          _.each(filter.activityTypes, function (type) {
            activityPickerConfig.addActivity({
              id: type,
              name: TinCanJS.getActivityTypeDisplay(type)
            });
          });
        }
        if (excludedActivitiesFilter && excludedActivitiesFilter.activityTypes) {
          _.each(excludedActivitiesFilter.activityTypes, function (type) {
            activityPickerConfig.excludeActivity({
              id: type,
              name: TinCanJS.getActivityTypeDisplay(type)
            });
          });
        }
        cfg.scope.activityIdsAreRegex = filter.activityIds ? filter.activityIds.regExp : false;
        cfg.scope.excludedActivityIdsAreRegex = false;
        if (filter.not && filter.not.or) {
          var i = _.findIndex(filter.not.or, function (f) {
            return f.activityIds !== undefined;
          });
          if (i > -1) {
            cfg.scope.excludedActivityIdsAreRegex = !!filter.not.or[i].activityIds && filter.not.or[i].activityIds.regExp;
          }
        }
        verbPickerConfig.selectedVerbs = [];
        verbPickerConfig.excludedVerbs = [];
        if (filter.verbIds || excludedVerbsFilter) {
          var verbIds = filter.verbIds ? filter.verbIds.ids : [];
          if (excludedVerbsFilter) {
            verbIds = verbIds.concat(excludedVerbsFilter.verbIds.ids);
          }
          Verbs.multiGetByVerbId(verbIds).then(function (results) {
            if (filter.verbIds) {
              _.each(filter.verbIds.ids, function (value) {
                var verb = _.findWhere(results.results, {
                  verbId: value
                });
                if (verb) {
                  verb.name = verb.display;
                  verbPickerConfig.addVerb(verb, immutable);
                } else {
                  verbPickerConfig.addVerb({
                    verbId: value,
                    name: value
                  }, immutable);
                }
              });
            }
            if (excludedVerbsFilter) {
              _.each(excludedVerbsFilter.verbIds.ids, function (value) {
                var verb = _.findWhere(results.results, {
                  verbId: value
                });
                if (verb) {
                  verb.name = verb.display;
                  verbPickerConfig.excludeVerb(verb, immutable);
                } else {
                  verbPickerConfig.excludeVerb({
                    verbId: value,
                    name: value
                  }, immutable);
                }
              });
            }
          });
        }
        cfg.scope.verbIdsAreRegex = filter.verbIds ? filter.verbIds.regExp : false;
        cfg.scope.excludedVerbIdsAreRegex = false;
        if (filter.not && filter.not.or) {
          var _i = _.findIndex(filter.not.or, function (f) {
            return f.verbIds !== undefined;
          });
          if (_i > -1) {
            cfg.scope.excludedVerbIdsAreRegex = filter.not.or[_i].verbIds.regExp;
          }
        }
        if (datePickerConfig) {
          datePickerConfig.dateFilter = filter.dateFilter || angular.copy(self.emptyDateFilter);
          datePickerConfig.complexTrailingOption = datePickerConfig.dateFilter.trailingAmount === 1 ? "1" : "0";
          var fromDate = datePickerConfig.dateFilter.customDateFrom;
          var toDate = datePickerConfig.dateFilter.customDateTo;
          var fromDateWithTimezone = getDateWithTimezone(fromDate);
          var toDateWithTimezone = getDateWithTimezone(toDate);
          var displayDate;
          var validFromDate = fromDate && fromDateWithTimezone.toString() !== 'Invalid Date';
          if (validFromDate) {
            var customDateFromPicker = $(".custom-date-from");

            // Adjust date handed to picker to local time, for proper display
            displayDate = new Date(fromDateWithTimezone);
            displayDate.setMinutes(displayDate.getMinutes() + fromDateWithTimezone.getTimezoneOffset());
            customDateFromPicker.datepicker('setDate', displayDate);
            datePickerConfig.fromDateOnSelect(fromDateWithTimezone);
          }
          var validToDate = toDate && toDateWithTimezone.toString() !== 'Invalid Date';
          if (validToDate) {
            var customDateToPicker = $(".custom-date-to");

            // Adjust date handed to picker to local time, for proper display
            displayDate = new Date(toDateWithTimezone);
            displayDate.setMinutes(displayDate.getMinutes() + toDateWithTimezone.getTimezoneOffset());
            customDateToPicker.datepicker('setDate', displayDate);
            toDateWithTimezone.setDate(toDateWithTimezone.getDate() - 1);
            datePickerConfig.toDateOnSelect(toDateWithTimezone);
          }
        }
        function getMenuItems(filters, categories) {
          var topLevelFilters = _.filter(filters, function (f) {
            return f.filterCategoryName === 'None';
          });
          var filterCategories = _.filter(categories, function (c) {
            if (c.filters === undefined) {
              return false;
            }
            var permittedFilters = _.filter(c.filters, function (cFilter) {
              return _.findWhere(filters, {
                id: cFilter.id
              });
            });
            c.filters = permittedFilters;
            return c.filters !== undefined && c.filters.length > 0;
          });
          var menuItems = _.sortBy(topLevelFilters.concat(filterCategories), 'menuPosition');
          return menuItems;
        }
        function addMenuItems(cfg, filters, categories) {
          var menuItems = getMenuItems(filters, categories);
          customFilterPickerConfig.availableFilters = customFilterPickerConfig.availableFilters.concat(menuItems);
        }
        if (customFilterPickerConfig) {
          customFilterPickerConfig.availableFilters = [];
          var _FilterRegistry$getAl = FilterRegistry.getAll({
              includeMetaData: true,
              includeFilterCategories: true
            }),
            filters = _FilterRegistry$getAl.filters,
            categories = _FilterRegistry$getAl.categories;
          addMenuItems(customFilterPickerConfig, filters, categories);
        }
        peoplePickerConfig.selectedPeopleOrGroups = [];
        peoplePickerConfig.excludedPeopleOrGroups = [];
        if (filter.personIds || filter.personCustomIds || filter.groupIds || filter.groupCustomIds || filter.groupTypeNames || excludedPeopleOrGroupsFilter || filter.excludeInactivePeople || Utils._try(function () {
          return filter.or[0].groupIds;
        }, false)) {
          peoplePickerConfig.excludeInactivePeople = filter.excludeInactivePeople;
          var personFetchCfg = {
            params: {
              customIds: (filter.personCustomIds || []).concat(excludedPeopleOrGroupsFilter ? excludedPeopleOrGroupsFilter.personCustomIds || [] : []),
              "_limit": 1000
            }
          };
          var groupFetchCfg = {
            params: {
              customIds: (filter.groupCustomIds || []).concat(excludedPeopleOrGroupsFilter ? excludedPeopleOrGroupsFilter.groupCustomIds || [] : []),
              "_limit": 1000
            }
          };
          var peopleUrl = People.multiGet((filter.personIds || []).concat(excludedPeopleOrGroupsFilter ? excludedPeopleOrGroupsFilter.personIds || [] : []), personFetchCfg);
          var groupIds = filter.groupIds || [];
          if (filter.or && filter.or.length > 0 && filter.or[0].excludeFromOutput && filter.or[0].groupIds) {
            groupIds = groupIds.concat(filter.or[0].groupIds);
          }
          if (filter.or && filter.or.length > 1 && filter.or[1].groupIds) {
            groupIds = groupIds.concat(filter.or[1].groupIds);
          }
          if (excludedPeopleOrGroupsFilter) {
            groupIds = groupIds.concat(excludedPeopleOrGroupsFilter.groupIds || []);
          }
          var groupUrl = Groups.multiGet(groupIds, groupFetchCfg);
          return $q.all([peopleUrl, groupUrl]).then(function (responses) {
            _.each(filter.personIds, function (value) {
              var person = _.findWhere(responses[0].results, {
                id: value
              });
              if (person) {
                peoplePickerConfig.personOrGroupSelected(person, immutable);
              }
            });
            _.each(filter.personCustomIds, function (value) {
              var person = _.findWhere(responses[0].results, {
                customId: value
              });
              if (person) {
                peoplePickerConfig.personOrGroupSelected(person, immutable);
              }
            });
            _.each(filter.groupIds, function (value) {
              var group = _.findWhere(responses[1].results, {
                id: value
              });
              if (group) {
                peoplePickerConfig.personOrGroupSelected(group, immutable);
              }
            });
            _.each(filter.groupCustomIds, function (value) {
              var group = _.findWhere(responses[1].results, {
                customId: value
              });
              if (group) {
                peoplePickerConfig.personOrGroupSelected(group, immutable);
              }
            });
            peoplePickerConfig.intersectGroups = filter.intersectGroups;
            if (filter.or && filter.or.length > 0 && filter.or[0].excludeFromOutput) {
              _.each(filter.or[0].groupIds, function (value) {
                var group = _.findWhere(responses[1].results, {
                  id: value
                });
                group.excludeFromOutput = true;
                if (group) {
                  peoplePickerConfig.personOrGroupSelected(group, immutable);
                }
              });
            }
            if (filter.or && filter.or.length > 1 && filter.or[1].groupIds) {
              _.each(filter.or[1].groupIds, function (value) {
                var group = _.findWhere(responses[1].results, {
                  id: value
                });
                if (group) {
                  peoplePickerConfig.personOrGroupSelected(group, immutable);
                }
              });
            }
            if (filter.groupTypeNames && filter.groupTypeNames.length) {
              // We're expecting that we've already called group-types once
              // and cached the results when we started Report Builder
              var groupTypes = GroupTypes.getCache();
              if (groupTypes.length) {
                filter.groupTypeNames = filter.groupTypeNames.map(function (name) {
                  var match = groupTypes.filter(function (g) {
                    return g.name === name;
                  });
                  if (match.length) {
                    return match[0];
                  } else {
                    return {
                      name: name
                    };
                  }
                });
              } else {
                filter.groupTypeNames = filter.groupTypeNames.map(function (n) {
                  return {
                    name: n
                  };
                });
              }
              _.each(filter.groupTypeNames, function (value) {
                peoplePickerConfig.personOrGroupSelected(value, immutable);
              });
            }
            if (excludedPeopleOrGroupsFilter) {
              _.each(excludedPeopleOrGroupsFilter.personIds, function (value) {
                var person = _.findWhere(responses[0].results, {
                  id: value
                });
                if (person) {
                  peoplePickerConfig.excludePersonOrGroup(person, immutable);
                }
              });
              _.each(excludedPeopleOrGroupsFilter.personCustomIds, function (value) {
                var person = _.findWhere(responses[0].results, {
                  customId: value
                });
                if (person) {
                  peoplePickerConfig.excludePersonOrGroup(person, immutable);
                }
              });
              _.each(excludedPeopleOrGroupsFilter.groupIds, function (value) {
                var group = _.findWhere(responses[1].results, {
                  id: value
                });
                if (group) {
                  peoplePickerConfig.excludePersonOrGroup(group, immutable);
                }
              });
              _.each(excludedPeopleOrGroupsFilter.groupCustomIds, function (value) {
                var group = _.findWhere(responses[1].results, {
                  customId: value
                });
                if (group) {
                  peoplePickerConfig.excludePersonOrGroup(group, immutable);
                }
              });
              _.each(excludedPeopleOrGroupsFilter.groupTypeNames || [], function (value) {
                peoplePickerConfig.excludePersonOrGroup({
                  name: value
                }, immutable);
              });
              peoplePickerConfig.intersectExcludedGroups = excludedPeopleOrGroupsFilter.intersectGroups;
            }
          });
        }
      },
      setIsVisible: function setIsVisible(isVisible) {
        _isVisible = isVisible;
      },
      getIsVisible: function getIsVisible() {
        return _isVisible;
      }
    };
    return self;
  }]).controller('ExplorerCtrl', ['$anchorScroll', '$filter', '$location', '$q', '$rootScope', '$route', '$scope', '$timeout', '$window', 'Activities', 'Alerts', 'CardGroup', 'CardRegistry', 'CardDisplay', 'CardQueryResource', 'CardTemplates', 'CardServices', 'CardUtils', 'ConfirmModal', 'Dashboards', 'DefaultCardGroups', 'Demo', 'ExplorerService', 'Groups', 'GroupUtils', 'Interactions', 'Logger', 'People', 'QueryWithProgress', 'User', 'UserRoles', 'Utils', 'Validation', 'wsConstants', 'wsEventNames', 'MeasureRegistry', 'GroupTypes', '$http', 'Api', 'OrganizationSettings', 'Verbs', 'ExplorerUtils', 'ChartUtils', 'AppPermissions', 'ViewDashboardsAs', 'ReportValidationService', 'QuickFilterEditorModel', 'CustomFilters', 'FilterRegistry', function ($anchorScroll, $filter, $location, $q, $rootScope, $route, $scope, $timeout, $window, Activities, Alerts, CardGroup, CardRegistry, CardDisplay, CardQueryResource, CardTemplates, CardServices, CardUtils, ConfirmModal, Dashboards, DefaultCardGroups, Demo, ExplorerService, Groups, GroupUtils, Interactions, Logger, People, QueryWithProgress, User, UserRoles, Utils, Validation, wsConstants, wsEventNames, MeasureRegistry, GroupTypes, $http, Api, OrganizationSettings, Verbs, ExplorerUtils, ChartUtils, AppPermissions, ViewDashboardsAs, ReportValidationService, QuickFilterEditorModel, CustomFilters, FilterRegistry) {
    Logger.debug("ExplorerCtrl");
    $scope.hasFeature = OrganizationSettings.hasFeature;
    var cleanupNavWatch = $rootScope.$on("nav:change", function () {
      var routeParams = $route.current.params;
      $scope.showExplorerTeaser = routeParams && routeParams.explorerPreview === 'true';
    });
    $scope.startDemo = Demo.startDemo.bind(Demo);
    $scope.isGroup = GroupUtils.isGroup;

    // -------------------------------
    // Top level UI miscellany
    // -------------------------------

    $scope.openSection = null;
    $scope.toggleSection = function toggleSection(section) {
      $scope.openSection = $scope.openSection === section ? null : section;
    };
    var lastCardPreviewed = null;
    var reloadPreview = _.debounce(function reloadPreview() {
      $scope.reloadPreviewButtonEnabled = false;

      // If we've already navigated away or saved just exit.  ShowExplorer will not be set upon entry
      // so will be undefined so check for that as well.
      if (!($scope.showExplorer === undefined || $scope.showExplorer)) {
        return;
      }
      Logger.trace("explorer:reloadPreview");
      $scope.previewInfo = null;
      var card = getCard();
      if (card.configuration && card.configuration.measures) {
        //prevent unnecessary reload, don't compare measures with categories and menu order attached
        card = angular.copy(card);
        card.configuration.measures = _.map(card.configuration.measures, function (m) {
          var measure = MeasureRegistry.get(m.id);
          return measure ? measure : m;
        });
      }
      if (card.configuration && card.configuration.customFilters) {
        card.configuration.customFilters = card.configuration.customFilters.map(function (f) {
          if (typeof f.id === 'undefined') {
            return f;
          }
          return FilterRegistry.get(f.id) || f;
        });
      }
      if (angular.equals(lastCardPreviewed, card)) {
        Logger.debug("explorer:reloadPreview - report has not changed, skipping preview reload");
        return;
      }

      // Cancel any current requests
      CardQueryResource.cancelAllOutstanding();

      // Reload card preview
      CardDisplay.loadCardPreview($scope, card, ".card-preview");

      // Init or reload detail preview
      var previewCard = getPreviewCard(),
        previewUrl = getCardDetailPath(previewCard);
      if (previewCard.id === 'preview' && previewCard.configuration && previewCard.configuration.measures) {
        previewCard.configuration.measures = _.chain(previewCard.configuration.measures).filter(function (m) {
          return m;
        }).map(function (m) {
          var measure = MeasureRegistry.get(m.id);
          return measure ? measure : m;
        }).value();
      }

      // Copy timezone info to value producer objects
      if (previewCard.configuration.timeZone) {
        previewCard.configuration.measures = _.map(previewCard.configuration.measures, function (m) {
          if (m.valueProducer) {
            m.valueProducer.timeZone = previewCard.configuration.timeZone;
            return m;
          }
        });
      }

      // Make sure preview card is in registry for detail preview
      CardRegistry.add(previewCard);

      // Either navigate to preview page, or reload it
      // strip leading/trailing slashes
      if ($location.url().replace(/^\/|\/$/g, '') !== previewUrl) {
        $location.url(previewUrl);
      } else {
        $route.reload();
      }
      lastCardPreviewed = card;
    }, 500);
    $scope.reloadPreview = reloadPreview;

    // When we find out that the card preview has fetched its data, use it to power
    // information about the preview.
    $rootScope.$on(wsEventNames.card.preview.loaded, function (evt, data) {
      $scope.previewInfo = null;

      // If we processed less than we found, this is a sample
      if (data && data.processedHits !== data.totalHits) {
        $scope.previewInfo = {
          samplePercent: data.processedHits * 100.0 / data.totalHits,
          statementCount: data.processedHits,
          totalStatements: data.totalHits
        };
      }
    });
    function setupCustomConfig(template) {
      // TODO: This state should be managed through ExplorerService
      $scope.hide.activity = false;
      $scope.hide.dates = false;
      $scope.hide.cardText = false;
      $scope.hide.customFilters = false;
      $scope.hide.advancedConfiguration = false;
      $scope.peoplePickerConfig.personPicker.singlePerson = false;
      $scope.activityPickerConfig.require.activity = false;
      if (template.configurationAssetLocation) {
        $scope.customConfigLocation = template.configurationAssetLocation;
        $scope.pickerConfig.customConfigLocation = template.configurationAssetLocation;
      } else {
        $scope.customConfigLocation = null;
        $scope.pickerConfig.customConfigLocation = null;
      }
    }

    // --------------------------------
    // Carousel
    // --------------------------------

    var carouselOffset = 0,
      carouselMoving = false;
    $scope.hideLeftArrow = true;
    function carouselMove(rightOrLeft, howMany) {
      if (carouselMoving) {
        return;
      }
      carouselMoving = true;
      howMany = howMany || 5;
      var tray = $(".viewport .tray"),
        currentLeft = parseInt(tray.css('left').replace("px", "")),
        shift = rightOrLeft === 'right' ? -136 : 136,
        carouselOffsetMin = 0,
        carouselOffsetMax = $scope.templates.length - 5;
      if (rightOrLeft === 'right') {
        howMany = Math.min(howMany, carouselOffsetMax - carouselOffset);
      } else {
        howMany = Math.min(howMany, carouselOffset - carouselOffsetMin);
      }
      var newLeft = currentLeft + shift * howMany;

      // Catch clicks that happened before arrows were hidden
      if (rightOrLeft === 'left' && $scope.hideLeftArrow) {
        carouselMoving = false;
        return;
      }
      if (rightOrLeft === 'right' && $scope.hideRightArrow) {
        carouselMoving = false;
        return;
      }
      carouselOffset += shift < 0 ? howMany : -howMany;
      $scope.hideLeftArrow = carouselOffset <= carouselOffsetMin;
      $scope.hideRightArrow = carouselOffset >= carouselOffsetMax;
      var done = function done() {
        carouselMoving = false;
      };
      tray.animate({
        'left': newLeft + 'px'
      }, {
        duration: 'fast',
        always: done
      });
    }
    function moveCarouselToSelectedTemplate() {
      if (!$scope.selectedTemplate) {
        return;
      }
      var itemOffset = $scope.templates.indexOf($scope.selectedTemplate);
      if (itemOffset < 0) {
        return;
      }
      var carouselWidth = 5,
        currentMaxOffset = carouselOffset + carouselWidth - 1;
      if (itemOffset > currentMaxOffset) {
        carouselMove('right', itemOffset - currentMaxOffset);
      } else if (itemOffset < carouselOffset) {
        carouselMove('left', carouselOffset - itemOffset);
      }
    }
    $scope.cardChangeHandlers = [];
    $scope.cardTitleChanged = function () {
      $scope.userProvidedTitle = true;
    };

    // Helper method for formatting the selection
    $scope.getParentAndGroupSelectionCounts = function (groupsAndPeople) {
      var counts = _.countBy(groupsAndPeople, function (entity) {
        return entity.personas ? 'people' : 'groups';
      });
      var personCount = counts.people ? counts.people : 0;
      var groupCount = counts.groups ? counts.groups : 0;
      var txt = "";
      if (personCount === 0 && groupCount === 0) {
        return null;
      } else {
        if (personCount > 0) {
          txt += personCount + " " + (personCount === 1 ? "person" : "people");
          if (groupCount > 0) {
            txt += " and ";
          }
        }
        if (groupCount > 0) {
          txt += groupCount + " " + (groupCount === 1 ? "group" : "groups");
        }
        return txt;
      }
    };
    $scope.getSelectedPeopleAndGroupsText = function (peoplePickerConfig) {
      var includedText = $scope.getParentAndGroupSelectionCounts(peoplePickerConfig.selectedPeopleOrGroups);
      var excludedText = $scope.getParentAndGroupSelectionCounts(peoplePickerConfig.excludedPeopleOrGroups);
      var txt = "";
      if (includedText !== null) {
        txt += includedText + " included";
        if (excludedText !== null) {
          txt += ", ";
        }
      }
      if (excludedText !== null) {
        txt += excludedText + " excluded";
      }
      if (includedText === null && excludedText === null) {
        if (peoplePickerConfig.personPicker && peoplePickerConfig.personPicker.singlePerson) {
          txt += 'No person selected';
        } else {
          txt += 'Everyone';
        }
      }
      return txt;
    };
    $scope.selectTemplate = function selectTemplate(template) {
      // If not changing templates, do nothing
      if ($scope.selectedTemplate.id === template.id) {
        return;
      }
      $scope.extendedHelpText = template.description;
      $scope.extendedHelpLabel = template.title;
      $scope.showHowToRead = false;

      //Change default title if the user has not provided one
      if ($scope.cardText && !$scope.userProvidedTitle) {
        $scope.cardText.title = "New " + template.title;
        setCardText($scope.cardText);
      }
      _.forEach($scope.cardChangeHandlers, function (handler) {
        handler(template);
      });
      $scope.cardChangeHandlers = []; // Only need to run handlers once per selected template
      $scope.selectedTemplate = template;

      // When changing templates, clear out the version
      if ($scope.workingConfig && $scope.workingConfig.version) {
        delete $scope.workingConfig.version;
      }
      setCardTemplate(template);
      setupCustomConfig(template);
      if (!template.configurationAssetLocation) {
        reloadPreview();
      }

      // Person page is a special case, since it only has one expose section let's be friendly
      // and expand it on entry.
      if (template.name === 'person') {
        $scope.openSection = 'people';
      } else {
        $scope.openSection = null;
      }
    };
    $scope.carouselMove = carouselMove;
    $scope.dialogChoice = {
      picker: false,
      toAdvanced: false,
      toSimple: false,
      pickerLoading: false
    };
    var cleanupDialogWatch = $scope.$watch("dialogChoice", function () {
      $scope.dialogHeight = $(".explore-main").height();
      $scope.pickerConfig.dialogHeight = $scope.dialogHeight;
    }, true);

    // -------------------------------
    // Picker
    // -------------------------------

    $scope.dialog = {
      show: false
    };
    $scope.pickerConfig = {
      dialogHeight: $scope.dialogHeight,
      dialogChoice: $scope.dialogChoice,
      dialog: $scope.dialog
    };

    // -------------------------------
    // Activities
    // -------------------------------

    $scope.activityPickerConfig = {
      selectedActivities: [],
      excludedActivities: [],
      pickerConfig: $scope.pickerConfig,
      require: {
        activity: false
      },
      scope: $scope
    };
    $scope.activityHelpText = {
      helpTitle: 'Activities',
      detailText: 'From the Activities section, choose which activities you want to analyze with this ' + 'report. You’ll be able to choose from any activity in your account that you have access to by using ' + 'the search bar or picking from a list of activities. '
    };

    // Special custom feature, action to generate measures for child activities of
    // the currently selected activities, see WSLRS-12066
    $scope.activityPickerConfig.handleGeneratedChildActivityMeasures = function (measures) {
      var _$scope$workingConfig;
      if (!$scope.workingConfig.measures) {
        $scope.workingConfig.measures = [];
      }
      (_$scope$workingConfig = $scope.workingConfig.measures).push.apply(_$scope$workingConfig, _toConsumableArray(measures));
      $scope.updateCardWithWorkingConfig();
    };

    // -------------------------------
    // Verbs
    // -------------------------------

    $scope.verbPickerConfig = {
      selectedVerbs: [],
      excludedVerbs: [],
      pickerConfig: $scope.pickerConfig
    };
    $scope.verbHelpText = {
      helpTitle: 'Verbs',
      detailText: 'From the Verbs section, choose which verbs you want to analyze with this ' + 'report. You’ll be able to choose from any verb in your account that you have access to by using ' + 'the search bar or picking from a list of verbs. '
    };

    // -------------------------------
    // Extensions
    // -------------------------------

    $scope.extensions = [];
    $scope.extensionsHelpText = {
      helpTitle: 'Extensions',
      detailText: 'From the Extensions section, choose which xAPI extension field/values you want to filter by with this report. ' + 'You will be able to choose from any xAPI extension by first selecting the extension field, then selecting one or values ' + 'using the search bars.  Note that you can retrieve a sampling of extension fields and values by entering "*" into the searchbar.'
    };
    $scope.selectedExtension = {};
    $scope.extensionTypeahead = function (query) {
      if (!query || !query.length) {
        return;
      }
      if (query === '*') {
        query = '';
      }
      return $http.get(Api.url('/search/extensions'), {
        params: {
          searchTerm: query
        }
      }).then(function activitySearchSuccess(response) {
        var extensions = _.map(response.data, function (extension) {
          return {
            "fieldName": extension.extensionId,
            "fieldType": extension.type,
            "display": $filter('esFieldDisplayName')(extension.extensionId)
          };
        });
        return _.sortBy(extensions, function (e) {
          return e.display;
        });
      });
    };
    $scope.extensionValuesTypeahead = function (query) {
      if (!query || !query.length) {
        return;
      }
      var qsParams = {
        searchTerm: query,
        fieldName: $scope.selectedExtension.field.fieldName,
        fieldType: $scope.selectedExtension.field.fieldType
      };
      if ($scope.selectedExtension.field.fieldType === "boolean") {
        if (query === '*') {
          return ["true", "false"];
        } else {
          return _.filter(["true", "false"], function (v) {
            return v.indexOf(query) > -1 && !_.contains($scope.equalsFilterToEdit.values.ids, v);
          });
        }
      }
      return $http.get(Api.url('/search/extension-values'), {
        params: qsParams
      }).then(function activitySearchSuccess(response) {
        var searchResults = response.data.results;
        // Don't include already-selected values
        searchResults = _.filter(searchResults, function (v) {
          return !_.contains($scope.equalsFilterToEdit.values.ids, v);
        });
        return searchResults;
      });
    };
    $scope.extensionSelected = function (item) {
      // Before we do anything, let's see if we already have an equals filter defined for this
      // field, and if so, this will turn into an "edit" of an existing extension even if they
      // started with "add" extension.
      var existingFilter = _.find($scope.workingConfig.filter.equals, function (equalsFilter) {
        return equalsFilter.fieldName === item.fieldName;
      });
      if (existingFilter) {
        $scope.equalsFilterToEdit = existingFilter;
      } else {
        $scope.equalsFilterToEdit.fieldName = item.fieldName;
        $scope.equalsFilterToEdit.fieldType = item.fieldType;
      }
      $scope.selectedExtension.field = item;
    };
    $scope.extensionValueSelected = function (value) {
      $scope.equalsFilterToEdit.values.ids.push(value);
      $scope.saveExtension();
      delete $scope.selectedExtension.value;
    };
    $scope.saveExtension = function () {
      var filter = $scope.workingConfig.filter;
      if (!filter.hasOwnProperty("equals") || filter.equals === null) {
        filter.equals = [];
      }

      // If this field isn't already in the main filter array, add it (it's new), otherwise it's an edit
      if (!_.contains(_.pluck(filter.equals, 'fieldName'), $scope.equalsFilterToEdit.fieldName)) {
        filter.equals.push($scope.equalsFilterToEdit);
      }

      //$scope.dialog.show = false;
      $scope.updateCardWithWorkingConfig();
    };
    $scope.deleteExtension = function (item) {
      $scope.workingConfig.filter.equals = _.filter($scope.workingConfig.filter.equals, function (e) {
        return e.fieldName !== item.fieldName;
      });
      $scope.updateCardWithWorkingConfig();
    };
    $scope.pickerConfig.deleteExtension = $scope.deleteExtension;
    $scope.removeExtensionValue = function (valueToRemove) {
      $scope.equalsFilterToEdit.values.ids = _.filter($scope.equalsFilterToEdit.values.ids, function (v) {
        return v !== valueToRemove;
      });
      if ($scope.equalsFilterToEdit.values.ids.length > 0) {
        $scope.saveExtension();
      } else {
        $scope.deleteExtension($scope.equalsFilterToEdit);
      }
    };
    $scope.editExtension = function (item) {
      $scope.equalsFilterToEdit = item;
      $scope.selectedExtension.value = null;
      $scope.selectedExtension.field = {
        fieldName: $scope.equalsFilterToEdit.fieldName,
        fieldType: $scope.equalsFilterToEdit.fieldType,
        display: $filter('esFieldDisplayName')($scope.equalsFilterToEdit.fieldName)
      };
      $scope.dialog.show = true;
      $scope.dialogChoice = {
        picker: false,
        toAdvanced: false,
        toSimple: false,
        pickerLoading: false
      };
      $scope.dialogChoice.editExtension = true;
    };
    $scope.pickerConfig.editExtension = $scope.editExtension;
    $scope.addExtension = function () {
      $scope.selectedExtension.value = null;
      $scope.selectedExtension.field = null;
      $scope.equalsFilterToEdit = {
        "fieldName": "",
        "fieldType": "",
        "values": {
          "ids": []
        },
        "exclude": false
      };

      // Now open the extensions modal
      $scope.openDialog('editExtension');
    };
    $scope.cardFilterHelpText = {
      helpTitle: 'Quick Filters',
      detailText: "Quick Filters allow your users to filter reports without needing to access Explore. " + "These filters, which aren't saved, are perfect for providing limited report control to users not familiar with Watershed. " + "<a target='_blank' href='https://watershedlrs.zendesk.com/hc/en-us/articles/360004919392'>Learn more</a>."
    };

    // ------------------------------
    // Time Zone
    // ------------------------------

    $scope.timezoneNames = moment.tz.names();
    $scope.clearTimeZone = function clearTimeZone() {
      delete $scope.workingConfig.timeZone;
      $scope.updateCardWithWorkingConfig();
    };
    $scope.timezoneHelpText = {
      helpTitle: 'Time Zone',
      detailText: 'Search from all available time zones and select the one you would like your ' + 'report created with.  This value effects filters and group-by date functionality'
    };

    // -------------------------------
    // People / Groups
    // -------------------------------

    $scope.peoplePickerConfig = {
      selectedPeopleOrGroups: [],
      intersectGroups: false,
      excludedPeopleOrGroups: [],
      intersectExcludedGroups: false,
      pickerConfig: $scope.pickerConfig,
      personPicker: $scope.personPicker,
      scope: $scope
    };
    $scope.peopleHelpText = {
      helpTitle: 'People',
      detailText: 'From the People section, choose which people this report will analyze. If you don’t ' + 'choose anyone, this report will analyze everyone whose data you have access to. To select specific ' + 'people or parts of your organization, use the search bar or pick from a list. You’ll be able to ' + 'select multiple people and parts of your organization.'
    };
    $scope.personHelpText = {
      helpTitle: 'Person',
      detailText: 'From the Person section, choose the person this report will analyze. This report will ' + 'analyze anyone whose data you have access to. To select a specific person, use the search bar or ' + 'pick from a list.'
    };
    $scope.showOutputFilterSection = function () {
      if (!$scope.showExplorer || !$scope.workingConfig) {
        return;
      }
      var isValidReport = $scope.workingConfig && $scope.workingConfig.type === "program" || $scope.workingConfig.dimensions && $scope.workingConfig.dimensions[0] && $scope.workingConfig.dimensions[0].statementProperty && $scope.workingConfig.dimensions[0].statementProperty.indexOf('groups.id') > -1;
      return isValidReport && _.filter($scope.peoplePickerConfig.selectedPeopleOrGroups, GroupUtils.isGroup).length > 0 && _.filter($scope.peoplePickerConfig.selectedPeopleOrGroups, function (g) {
        return !g.personas && !g.peopleIds;
      }).length > 0;
    };
    $scope.excludedGroupsCount = function excludedGroupsCount() {
      return _.chain($scope.peoplePickerConfig.selectedPeopleOrGroups).filter(GroupUtils.isGroup).where({
        excludeFromOutput: true
      }).value().length;
    };

    // -------------------------------
    // Dialog
    // -------------------------------

    // Actions to take for specific pickers.
    // This is just a central point to launch the different pickers from their configs.
    $scope.pickerActions = {
      activityPicker: $scope.activityPickerConfig,
      verbPicker: $scope.verbPickerConfig,
      peoplePicker: $scope.peoplePickerConfig
    };
    $scope.openDialog = function openDialog(type, isCustom) {
      $scope.dialog.show = true;
      $scope.dialogChoice = {
        picker: false,
        toAdvanced: false,
        toSimple: false,
        pickerLoading: false,
        isCustom: isCustom
      };
      $scope.pickerConfig.dialogChoice = $scope.dialogChoice;

      // set the dialogChoice option, then resolve dialogChoice.customConfig
      $scope.dialogChoice[type] = true;
      if (type.toLowerCase().indexOf("picker") !== -1) {
        $scope.dialogChoice.picker = true;
        if ($scope.pickerActions[type]) {
          $scope.dialogChoice.pickerLoading = null;
          $timeout(function () {
            if ($scope.dialogChoice.pickerLoading === null) {
              $scope.dialogChoice.pickerLoading = true;
            }
          }, 1000);
          $scope.pickerActions[type].buildPicker();
        }
      }
    };
    $scope.activityPickerConfig.openDialog = $scope.openDialog;
    $scope.peoplePickerConfig.openDialog = $scope.openDialog;
    $scope.verbPickerConfig.openDialog = $scope.openDialog;
    $scope.pickerConfig.openDialog = $scope.openDialog;

    // -------------------------------
    // Dates
    // -------------------------------

    $scope.earliestStatementDate = null; // Set by ensureOrganizationState()
    $scope.today = new Date();
    var emptyDateFilter = {
      dateType: 'none',
      trailingAmount: 1,
      trailingType: 'days',
      customDateFrom: null,
      customDateTo: null
    };
    $scope.dateFilter = angular.copy(emptyDateFilter);
    $scope.datePickerConfig = {
      dateFilter: $scope.dateFilter
    };
    $scope.datesHelpText = {
      helpTitle: 'Dates',
      detailText: 'From the Dates section, select a time range for your report to analyze. Use Trailing to ' + 'select the previous X days/weeks/months/years from today. While the range stays the same, the dates ' + 'change to keep up with the current date. Use the Custom option to choose a specific date range. If ' + 'you don’t select any dates, the report will analyze all statements in the account.'
    };

    // -------------------------------
    // Persistent Filters
    // -------------------------------
    $scope.filterPicker = {
      disabled: false
    };
    $scope.customFilterPickerConfig = {
      availableFilters: [],
      selectedFilter: null,
      // todo: array
      pickerConfig: $scope.pickerConfig,
      scope: $scope
    };
    var clearPreviousFilterWatcher = createFilterWatcher();
    $scope.$on('working-config-reassigned', rebuildFilterWatcherFromNewReference);
    function createFilterWatcher() {
      return $scope.$watchCollection('workingConfig.customFilters', function (customFilters, oldCustomFilters) {
        $scope.customFilters = customFilters;
        if (customFilters !== oldCustomFilters && $scope.showExplorer) {
          $scope.updateCardWithWorkingConfig();
        }
      });
    }
    function rebuildFilterWatcherFromNewReference(event, newWorkingConfigReference) {
      $scope.customFilters = newWorkingConfigReference.customFilters;
      clearPreviousFilterWatcher();
      clearPreviousFilterWatcher = createFilterWatcher();
    }
    $scope.$watch('filterMenuOpen', function (isOpen) {
      if (!isOpen) {
        $scope.textFilter = {};
      }
    });
    $scope.getFilterName = function getFilterName(filter) {
      var filterName = 'anonymous';
      if (typeof filter !== 'undefined') {
        var topLevelFilters = $scope.customFilterPickerConfig.availableFilters.filter(function (f) {
          return typeof f.config !== 'undefined';
        });
        var categorizedFilters = $scope.customFilterPickerConfig.availableFilters.filter(function (f) {
          return typeof f.filters !== 'undefined';
        }).map(function (c) {
          return c.filters;
        });
        var customFilters = topLevelFilters.concat.apply(topLevelFilters, _toConsumableArray(categorizedFilters));
        var customFilter = customFilters.find(function (_ref) {
          var id = _ref.id;
          return filter.id === id;
        });
        if (customFilter) {
          filterName = customFilter.name;
        }
      }
      return filterName;
    };
    $scope.saveFilter = function saveFilter() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          supressReload: false,
          filter: null
        },
        supressReload = _ref2.supressReload,
        filter = _ref2.filter;
      if (!Array.isArray($scope.customFilters)) {
        $scope.customFilters = [];
      }
      if (filter) {
        $scope.customFilters.push(filter);
      }
      $scope.workingConfig.customFilters = $scope.customFilters; // todo: delete if empty (see removeFilter)?
      $scope.workingConfig.type = $scope.templateType;
      $scope.updateCardWithWorkingConfig(supressReload);
      $scope.filterMenuOpen = false;
      $timeout(function () {
        angular.element(document.querySelector('#filterPickerDropdownButton')).triggerHandler('click');
      }, 0);
    };
    $scope.removeFilter = function removeFilter(i) {
      if (typeof i === 'number' && Array.isArray($scope.customFilters) && $scope.customFilters.length > i && Array.isArray($scope.workingConfig.customFilters) && $scope.workingConfig.customFilters.length > i) {
        $scope.customFilters = $scope.customFilters.slice(0, i).concat($scope.customFilters.slice(i + 1));
        $scope.workingConfig.customFilters = $scope.customFilters;
        if ($scope.customFilters.length === 0) {
          $scope.customFilters = null;
          delete $scope.workingConfig.customFilters;
        }
        $scope.workingConfig.type = $scope.templateType;
        $scope.updateCardWithWorkingConfig();
      }
    };
    $scope.customFilterHelpText = {
      helpTitle: 'Custom Filters',
      detailText: "Choose any number of custom filters to use on this report. This report will " + "apply the selected filters, along with any filters chosen in the Activities, People, ... " + "sections above.  The result will be equivalent to adding each of the selected custom filters " + "to the 'filter.and' property in the advanced config."
    };
    var explorerUtilsCfg = {
      activityPickerConfig: $scope.activityPickerConfig,
      verbPickerConfig: $scope.verbPickerConfig,
      peoplePickerConfig: $scope.peoplePickerConfig,
      datePickerConfig: $scope.datePickerConfig,
      customFilterPickerConfig: $scope.customFilterPickerConfig,
      scope: $scope
    };

    // -------------------------------
    // Advanced Editor (ACE)
    // -------------------------------

    $scope.advancedOptions = {
      enableSnippets: true,
      enableBasicAutocompletion: true,
      enableLiveAutocompletion: true
    };
    $scope.aceLoaded = function (_editor) {
      $scope.editor = _editor;
      var session = _editor.getSession();
      session.setMode("ace/mode/json");
      session.setTabSize(2);
      session.setUseSoftTabs(true);
    };

    /**
     * Return the config with a separate "comments" property with all the comments from the config
     * @returns {
     *     ...AdvancedConfig,
     *     comments: []
     * }
     */
    function splitCommentsFromEditorValue() {
      var value = $scope.editor.getValue();
      var comments = {};

      //remove comments from all lines and capture them in the comments object
      value = _.map(value.split('\n'), function (l, i) {
        // even number of quotes followed by a comment,
        if (/^[^"]*("[^"]*"[^"]*)*\/\/.*$/.test(l)) {
          // if the entire line is a comment just capture the row number otherwise row number + A for append
          i = /^\s*\/\/.*/.test(l) ? i : i + 'A';
          var line = l.split('//');
          //separate comments from the line
          comments[i] = line[line.length - 1];
          return line.slice(0, line.length - 1).join('//');
        }
        return l;
      }).join('\n');
      var config = JSON.parse(value);
      config.comments = comments;
      return config;
    }
    function validateCustomDateFilter(config) {
      if (config && config.filter && config.filter.dateFilter) {
        //check custom date from and to in dateFilter and display a warning if they are invalid
        var warnings = [];
        _.each([config.filter.dateFilter.customDateFrom, config.filter.dateFilter.customDateTo], function (date) {
          if (date && (['now', 'today'].indexOf(date.toLowerCase()) < 0 && new Date(date)).toString() === "Invalid Date" && moment.duration(date).as('ms') === 0) {
            var pos = $scope.editor.find(date);
            if (pos && pos.start) {
              warnings.push({
                row: pos.start.row,
                column: pos.start.column,
                text: "The custom date is invalid\nDates should be ISO 8601\nExample: 2018-01-24T06:12:30.000Z",
                type: "error"
              });
            }
          }
        });
        $scope.editor.getSession().getAnnotations();
        if (warnings.length > 0) {
          $scope.editor.getSession().setAnnotations(warnings);
        }
      }
    }
    function validateIncludePeopleWithoutStatements(config) {
      if (!(config && config.includePeopleWithoutStatements)) {
        return;
      }
      var warnings = [];
      var isConstantDimension = config.dimensions[0].type === 'CONSTANT';
      var firstDimension = config.dimensions[0].statementProperty;
      var validDimensions = ['actors.person.id', 'actor.person.id', "actors.groups.id", "actor.groups.id"];
      if (!validDimensions.includes(firstDimension) && !isConstantDimension) {
        var pos = $scope.editor.find("includePeopleWithoutStatements");
        if (pos && pos.start) {
          warnings.push({
            row: pos.start.row,
            column: pos.start.column,
            text: "includePeopleWithoutStatements only works with dimension: actors.person.id or actors.groups.id",
            type: "error"
          });
        }
      }
      $scope.editor.getSession().getAnnotations();
      if (warnings.length > 0) {
        $scope.editor.getSession().setAnnotations(warnings);
      }
    }
    $scope.aceChanged = _.debounce($scope.$safeApply.bind($scope, function () {
      try {
        var config = splitCommentsFromEditorValue();
        validateCustomDateFilter(config);
        validateIncludePeopleWithoutStatements(config);
        var warnings = $scope.editor.getSession().getAnnotations();
        if (warnings.length) {
          return;
        }
        if (!angular.equals($scope.workingConfig, config)) {
          $scope.advancedConfigUsed = true;
        }

        // New object from empty config + our parsed config
        $scope.workingConfig = _.extend({}, emptyConfig, config);
        $scope.$broadcast('working-config-reassigned', $scope.workingConfig);

        // If changes, update config and reload the preview
        var cardConfig = getWorkingConfig();
        if (!_.isEqual(cardConfig, getCard().configuration)) {
          setCardConfig(cardConfig);
          FilterRegistry.setCustomFiltersOnCard(getCard());
          if ($scope.workingConfig.type === "program") {
            $scope.reloadPreviewButtonEnabled = true;
          } else {
            reloadPreview();
          }
        }
      } catch (error) {
        if (error.name === 'SyntaxError') {
          Logger.debug(error);
          return;
        }
        throw error;
      }
    }), 2000);

    // -------------------------------
    // Bottom menu
    // -------------------------------

    $scope.showAdvanced = function showAdvanced() {
      $scope.showAdvancedEditor = true;
      $scope.dialog.show = false;
      //check if user is ws employee
      var config = angular.copy($scope.workingConfig);

      // Clear out timezones on measures which are just used to render... the main timeZone value
      // will be copied over to the valueProducers before rendering. Do the same thing for statementPRoperty
      // on match in array.
      if (config.measures) {
        config.measures = _.map(config.measures, function (m) {
          if (m.valueProducer && m.valueProducer.timeZone) {
            delete m.valueProducer.timeZone;
          }
          if (m.valueProducer && m.valueProducer.type && m.valueProducer.type === 'MATCH_IN_ARRAY') {
            delete m.valueProducer.statementProperty;
          }
          return m;
        });
      }
      //copy and then remove the comments property from the config
      var comments = angular.copy(config.comments);
      delete config.comments;
      var value = angular.toJson(config, 2).split('\n');

      //add the comments into the ace editor value
      _.chain(comments).pairs().sortBy(function (a) {
        //sort the comments based on the row so we insert lines starting at the top of the editor
        var l = a[0];
        if (l.indexOf('A') > -1) {
          l = l.replace('A', '');
        }
        return parseInt(l);
      }).each(function (a) {
        //if the key ends with 'A' we append to the end of the line
        if (a[0].indexOf('A') > -1) {
          value[parseInt(a[0].replace('A', ''))] += '//' + a[1];
        } else {
          //othewise we insert into the row specified
          value.splice(parseInt(a[0]), 0, '//' + a[1]);
        }
      });
      $scope.editor.setValue(value.join('\n'), -1);
    };
    $scope.showSimple = function showSimple() {
      $scope.showAdvancedEditor = false;
      $scope.dialog.show = false;
      populateSimpleModeScope($scope.workingConfig.filter, explorerUtilsCfg);
    };
    $scope.saveAsNewCard = _.debounce($scope.$safeApply.bind($scope, function saveAsNewCard() {
      function createSuccess(card) {
        var dashboardPromise;
        if (card.isMeCard) {
          dashboardPromise = DefaultCardGroups.ensureExist().then(function (groupMap) {
            return groupMap["Your Reports"];
          });
        } else {
          dashboardPromise = Dashboards.get().then(function (dashboards) {
            var defaultDashboard;
            if (Dashboards.currentDashboard.name === "Your Reports") {
              defaultDashboard = dashboards["Your Reports"];
            } else {
              defaultDashboard = _.findWhere(dashboards, {
                id: User.get().membership.defaultDashboardId
              });
            }
            if (defaultDashboard === null || _.isUndefined(defaultDashboard)) {
              defaultDashboard = _.findWhere(dashboards, {
                name: "Dashboard"
              });
            }
            return defaultDashboard;
          });
        }
        dashboardPromise.then(function (dashboard) {
          dashboard.previousCardIds = null;
          dashboard.cardIds.push(card.id);
          card.cardGroupIds = [dashboard.id];
          CardGroup.save(dashboard, {
            params: {
              updateCategory: false,
              addOnly: true
            }
          }).then(function () {
            Alerts.raiseAlert({
              type: 'success',
              text: 'Created new report in ' + dashboard.name
            });
            closeExplorer(true);
            $location.url($scope.originalLocation ? $scope.originalLocation : "/dashboard/" + dashboard.id);
          });
        });
      }

      // Make sure card text is up to date
      setCardText(getWorkingText());
      $scope.updateCardWithWorkingConfig(true);
      if (!validateCard()) {
        return;
      }
      function saveNewCard() {
        try {
          QuickFilterEditorModel.saveAndIgnoreErrors();
          var config = getWorkingConfig(),
            card = getCard(),
            newCard = {
              configuration: config,
              organization: card.organization,
              template: card.template,
              title: card.title,
              summary: card.summary,
              description: card.description,
              persisted: false
            };
          FilterRegistry.setCustomFiltersOnCard(newCard);
          if ($scope.userIsAdmin()) {
            CardServices.saveConfiguration(newCard, createSuccess, createSuccess, $scope.advancedConfigUsed);
          } else {
            newCard.isMeCard = true;
            DefaultCardGroups.ensureExist().then(function (groupMap) {
              newCard.cardGroupIds = [groupMap['Your Reports'].id];
              CardServices.saveConfiguration(newCard, createSuccess, createSuccess, $scope.advancedConfigUsed);
            });
          }
        } catch (error) {
          if (error.name === 'SyntaxError') {
            $scope.advancedError = "The entered configuration is invalid.";
            return;
          }
          throw error;
        }
      }
      if (getCard().title.toLowerCase() === $scope.originalTitle.toLowerCase() && $scope.hide.cardText !== true) {
        var modal = {
          title: "Save As New Report",
          subtitle: "You have not changed the report title.",
          body: "Are you sure you want to save this as a new report?",
          cancelBtn: "Return to Editing",
          confirmBtn: "Save New Report",
          confirm: saveNewCard
        };
        ConfirmModal.open($scope, modal);
      } else {
        saveNewCard();
      }
    }), 500, true);
    $scope.userIsAdmin = function userIsAdmin() {
      return UserRoles.isOrgManager(User.get());
    };
    $scope.updateCard = _.debounce($scope.$safeApply.bind($scope, function updateCard() {
      function updateSuccess() {
        Alerts.raiseAlert({
          type: 'success',
          text: 'Saved changes to report'
        });
        $location.url(getCardDetailPath(getCard()));
        closeExplorer(true);
      }
      if (!validateCard()) {
        return;
      }
      if (!$scope.canEditCard) {
        Alerts.raiseAlert({
          type: 'danger',
          text: "You don't have permission to update this report"
        });
        return;
      }
      function saveCard() {
        try {
          // Just in case our watches didn't ensure the card text and
          // config were up to date, make sure that they indeed are
          setCardText(getWorkingText());
          if ($scope.showAdvancedEditor === true) {
            var config = splitCommentsFromEditorValue();
            $scope.workingConfig = _.extend({}, emptyConfig, config);
          }
          QuickFilterEditorModel.saveAndIgnoreErrors();
          var cfg = getWorkingConfig();
          setCardConfig(cfg);

          // Then save the card
          var cd = getCard();
          FilterRegistry.setCustomFiltersOnCard(cd);
          CardServices.saveConfiguration(cd, updateSuccess, updateSuccess, $scope.advancedConfigUsed);
        } catch (error) {
          if (error.name === 'SyntaxError') {
            $scope.advancedError = "The entered configuration is invalid.";
            return;
          }
          throw error;
        }
      }
      if ($scope.externalConnection) {
        var modal = {
          title: "Saving report with external connections",
          subtitle: "This report has shares that may be powering an external connection. Saving changes to this report may disrupt these connections.",
          body: "Are you sure you want to change this report?",
          cancelBtn: "Return to Editing",
          confirmBtn: "Save",
          confirm: saveCard
        };
        ConfirmModal.open($scope, modal);
      } else {
        saveCard();
      }
    }), 500, true);
    $scope.reset = function reset() {
      // If we haven't changed the config around at all, don't prompt for confirmation
      if (_.isEqual(getWorkingConfig(), $scope.originalConfig)) {
        resetExplorer();
        return;
      }
      var modal = {
        title: "Reset",
        subtitle: "You have unsaved changes. Are you sure you want to remove them?",
        body: "If you click \"Reset\", you will lose all of your changes. You won't be able to undo this action.",
        cancelBtn: "Cancel",
        confirmBtn: "Reset",
        confirm: resetExplorer
      };
      ConfirmModal.open($scope, modal);
    };
    function resetExplorer() {
      exploreCard($scope.originalCard);
    }
    $scope.cancel = function cancel(suppressRedirect, event) {
      // If we haven't changed the config around at all, don't prompt for confirmation
      if (_.isEqual(getWorkingConfig(), $scope.originalConfig)) {
        closeExplorer(suppressRedirect);
        return;
      }
      var newUrl = null;
      if (event) {
        //first stop the redirect until we've asked if they really want to cancel; capture newUrl
        event.preventDefault();
        newUrl = $location.$$url;
      }
      var modal = {
        title: "Exit Report Builder?",
        body: "You have unsaved changes. Are you sure you want to exit?",
        cancelBtn: "No",
        confirmBtn: "Yes",
        confirm: function confirm() {
          closeExplorer(suppressRedirect);
          if (newUrl) {
            $location.path(newUrl);
          }
        }
      };
      ConfirmModal.open($scope, modal);
    };
    function closeExplorer(suppressRedirect) {
      $scope.showExplorer = false;
      ExplorerUtils.setIsVisible(false);
      setCard(null);
      resetSessionState();
      if (!suppressRedirect) {
        $location.url($scope.isNewCard ? "/" : $scope.originalLocation);
      }
      ChartUtils.clearTooltips();
      $rootScope.$broadcast("nav:change", null);
    }

    // -------------------------------
    // Card state
    // -------------------------------

    function getCardDetailPath(card) {
      return CardUtils.getCardUrl(card, true);
    }
    function getCard() {
      return ExplorerService.getCard();
    }
    function setCard(card) {
      return ExplorerService.setCard(card);
    }
    function getPreviewCard() {
      return _.extend({}, getCard(), {
        id: "preview"
      });
    }
    function setCardTemplate(template) {
      var card = getCard();
      card.template = template;
      setCard(card);
    }
    function setCardConfig(config) {
      var card = getCard();
      card.configuration = config;
      setCard(card);
    }

    // -------------------------------
    // "Working configuration" state
    // -------------------------------

    var emptyConfig = {
      filter: {
        activityIds: null,
        personIds: null,
        groupIds: null,
        dateFilter: emptyDateFilter
      },
      quickFilters: _.extend({
        activities: {
          type: 'all'
        },
        people: {
          type: 'all'
        },
        verbs: {
          type: 'all'
        },
        dates: {
          type: 'all'
        }
      }, OrganizationSettings.hasFeature("defaultQuickFilters"))
    };

    // TODO: Manage access to this through ExplorerService
    $scope.workingConfig = angular.copy(emptyConfig);
    function updateFilterDefaultsForOrg(orgSettings) {
      emptyConfig.filter.includeRelatedActivities = orgSettings.relatedActivitiesFilterDefault;
      $scope.extensionsFilterEnabled = orgSettings.extensionsFilterEnabled;
      $scope.activityPickerConfig.relatedActivitiesFilterEnabled = orgSettings.relatedActivitiesFilterEnabled;
      $scope.activityPickerConfig.generateRelatedActivityMeasuresEnabled = OrganizationSettings.hasFeature("generateRelatedActivityMeasures");
      emptyConfig.quickFilters = _.extend({
        activities: {
          type: 'all'
        },
        people: {
          type: 'all'
        },
        verbs: {
          type: 'all'
        },
        dates: {
          type: 'all'
        }
      }, OrganizationSettings.hasFeature("defaultQuickFilters"));
    }

    // Handle page refreshes when org has already been selected
    if (User.get().organization) {
      OrganizationSettings.get(User.get().organization.id).then(function (orgSettings) {
        updateFilterDefaultsForOrg(orgSettings);
      });
    }

    // When organization changes, re-init
    $rootScope.$on('organization-selected', function () {
      OrganizationSettings.get(User.get().organization.id).then(function (orgSettings) {
        updateFilterDefaultsForOrg(orgSettings);
      });
    });

    // When settings are updated, refresh the configurable explorer filter items
    $rootScope.$on('organization-settings-updated', function (event, orgSettings) {
      updateFilterDefaultsForOrg(orgSettings);
    });

    //In a few known cases, we want to update the working config, but the config doesn't need to be reloaded
    $scope.updateCardWithWorkingConfig = function (suppressReload) {
      setCardConfig(getWorkingConfig());
      if (!suppressReload) {
        if ($scope.workingConfig.type === "program") {
          $scope.reloadPreviewButtonEnabled = true;
        } else {
          reloadPreview();
        }
      }
    };
    $scope.pickerConfig.updateCardWithWorkingConfig = $scope.updateCardWithWorkingConfig;

    // Clean up any filters that are empty or have all null values
    var cleanupEmptyOrNull = function cleanupEmptyOrNull(filterToCleanup) {
      return filterToCleanup.filter(function (f) {
        var keys = Object.keys(f);
        // If no keys (i.e. empty object) filter it out
        if (!keys) {
          return false;
        }

        // If all null values, filter it out
        var allNullValues = keys.map(function (k) {
          return f[k];
        }).filter(Boolean).length === 0;
        return !allNullValues;
      });
    };
    var cleanupBadgeWatch = $scope.$watch('badgePickerConfig.selectedBadge', function (badge) {
      if (!$scope.showExplorer) {
        return;
      }
      var activityIds = new Set();
      var verbIds = new Set();
      badge.config.criteria.map(function (criteria) {
        criteria.filter.activityIds.ids.map(function (id) {
          return activityIds.add(id);
        });
        criteria.filter.verbIds.ids.map(function (id) {
          return verbIds.add(id);
        });
      });
      $scope.workingConfig.filter.activityIds = {
        ids: _toConsumableArray(activityIds)
      };
      $scope.workingConfig.filter.verbIds = {
        ids: _toConsumableArray(verbIds)
      };
      $scope.updateCardWithWorkingConfig();
    });

    //keep current configFilter updated with simple configuration changes
    var cleanupDateFilterWatch = $scope.$watchCollection('datePickerConfig.dateFilter', function (item) {
      if (!$scope.showExplorer) {
        return;
      }
      var dateFilter = angular.copy(item);

      //when user initially switches to custom date filter, pre-populate it with all statements date range
      if (dateFilter.dateType === 'custom' && dateFilter.customDateFrom === null && dateFilter.customDateTo === null) {
        //set the from date to one month ago or the earliers statement date whichever is most later
        var oneMonthAgo = new Date();
        oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
        var minDate = oneMonthAgo < $scope.earliestStatementDate ? oneMonthAgo : $scope.earliestStatementDate;
        if (typeof minDate === 'undefined') {
          minDate = oneMonthAgo;
        }
        dateFilter.customDateFrom = minDate;
        var minYear = minDate.getFullYear();
        $scope.dateFilter.customDateFrom = dateFilter.customDateFrom;
        $(".custom-date-from").datepicker('setDate', dateFilter.customDateFrom);
        $(".custom-date-from").datepicker('option', 'yearRange', "".concat(minYear, ":+0"));
        dateFilter.customDateTo = $scope.today;
        $scope.dateFilter.customDateTo = dateFilter.customDateTo;
        $(".custom-date-to").datepicker('setDate', dateFilter.customDateTo);
        $(".custom-date-to").datepicker('option', 'yearRange', "".concat(minYear, ":+0"));
      }
      $scope.workingConfig.filter.dateFilter = dateFilter;
      $scope.updateCardWithWorkingConfig();
    });
    var cleanupActivitiesWatch = $scope.$watchCollection('activityPickerConfig.selectedActivities', function (item) {
      if (!$scope.showExplorer) {
        return;
      }
      var actIds = item.filter(function (i) {
        return i.activityId;
      }).map(function (a) {
        return a.activityId;
      });
      var activityTypes = item.filter(function (i) {
        return !i.activityId;
      }).map(function (a) {
        return a.id;
      });
      $scope.workingConfig.filter.activityIds = _.isEmpty(actIds) ? null : {
        ids: actIds,
        regExp: $scope.activityIdsAreRegex
      };
      $scope.workingConfig.filter.activityTypes = _.isEmpty(activityTypes) ? null : activityTypes;
      $scope.updateCardWithWorkingConfig();
    });
    $scope.$watchCollection('activityPickerConfig.includeRelatedActivities', function (val) {
      $scope.workingConfig.filter.includeRelatedActivities = val;
    });
    var cleanupExcludedActivitiesWatch = $scope.$watchCollection('activityPickerConfig.excludedActivities', function (item) {
      if (!$scope.showExplorer) {
        return;
      }
      var actIds = [];
      var activityTypes = [];
      $scope.workingConfig.filter.not = $scope.workingConfig.filter.not || {};
      $scope.workingConfig.filter.not.or = $scope.workingConfig.filter.not.or || [];
      _.each(item, function (a) {
        if (a.activityId) {
          actIds.push(a.activityId);
        } else {
          activityTypes.push(a.id);
        }
      });
      var filter = {
        activityIds: _.isEmpty(actIds) ? null : {
          ids: actIds,
          regExp: !!$scope.excludedActivityIdsAreRegex
        },
        activityTypes: Utils.ifEmptyThenNull(activityTypes)
      };
      var i = _.findIndex($scope.workingConfig.filter.not.or, function (f) {
        return f.activityIds !== undefined || f.activityTypes !== undefined;
      });
      if (i > -1) {
        $scope.workingConfig.filter.not.or[i] = filter;
      } else {
        $scope.workingConfig.filter.not.or.push(filter);
      }
      $scope.workingConfig.filter.not.or = cleanupEmptyOrNull($scope.workingConfig.filter.not.or);
      $scope.updateCardWithWorkingConfig();
    });
    var cleanupVerbsWatch = $scope.$watchCollection('verbPickerConfig.selectedVerbs', function (item) {
      if (!$scope.showExplorer) {
        return;
      }
      var verbIds = _.pluck(item, 'verbId');
      if ($scope.workingConfig.filter.verbIds) {
        $scope.verbIdsAreRegex = $scope.workingConfig.filter.verbIds.regExp;
      }
      $scope.workingConfig.filter.verbIds = _.isEmpty(verbIds) ? null : {
        ids: verbIds,
        regExp: $scope.verbIdsAreRegex
      };
      $scope.updateCardWithWorkingConfig();
    });
    var cleanupExcludedVerbsWatch = $scope.$watchCollection('verbPickerConfig.excludedVerbs', function (item) {
      if (!$scope.showExplorer) {
        return;
      }
      var verbIds = item.map(function (i) {
        return i.verbId;
      });
      $scope.workingConfig.filter.not = $scope.workingConfig.filter.not || {};
      $scope.workingConfig.filter.not.or = $scope.workingConfig.filter.not.or || [];
      var i = _.findIndex($scope.workingConfig.filter.not.or, function (f) {
        return f.verbIds !== undefined;
      });
      var filter = {
        verbIds: _.isEmpty(verbIds) ? null : {
          ids: verbIds,
          regExp: $scope.excludedVerbIdsAreRegex
        }
      };
      if (i > -1) {
        $scope.workingConfig.filter.not.or[i] = filter;
      } else {
        $scope.workingConfig.filter.not.or.push(filter);
      }
      $scope.workingConfig.filter.not.or = cleanupEmptyOrNull($scope.workingConfig.filter.not.or);
      $scope.updateCardWithWorkingConfig();
    });
    var cleanupPeopleOrGroupsWatch = $scope.$watch('peoplePickerConfig.selectedPeopleOrGroups', function (item) {
      if (!$scope.showExplorer) {
        return;
      }

      // Drop any null items that might have snuck in
      item = _.filter(item, function (item) {
        return !!item;
      });
      var people = _.filter(item, function (item) {
        return item.personas;
      });
      var personIds = [];
      var personCustomIds = [];
      _.each(people, function (person) {
        if (person.customId) {
          personCustomIds.push(person.customId);
        } else {
          personIds.push(person.id);
        }
      });
      $scope.workingConfig.filter.personIds = Utils.ifEmptyThenNull(personIds);
      $scope.workingConfig.filter.personCustomIds = Utils.ifEmptyThenNull(personCustomIds);
      var groups = _.filter(item, function (item) {
        return item.peopleIds;
      });
      var groupIds = [];
      var groupCustomIds = [];
      var groupIdsExcludedFromOutput = [];
      _.each(groups, function (group) {
        if (group.excludeFromOutput) {
          groupIdsExcludedFromOutput.push(group.id);
        }
        if (group.customId) {
          groupCustomIds.push(group.customId);
        } else {
          groupIds.push(group.id);
        }
      });
      $scope.workingConfig.filter.groupCustomIds = Utils.ifEmptyThenNull(groupCustomIds);
      function hasOrFilter(filter) {
        return filter.or && filter.or.length > 0;
      }
      function hasExcludedGroupIdsFilter(filter) {
        return hasOrFilter(filter) && filter.or[0].excludeFromOutput && filter.or[0].groupIds;
      }
      function isExcludeGroupIdsFilter(filter) {
        return filter.excludeFromOutput && filter.groupIds;
      }
      function shouldAddExcludedGroupsToOrFilter() {
        return groupIdsExcludedFromOutput.length > 0;
      }

      // add/remove groups from filter OR
      if (shouldAddExcludedGroupsToOrFilter()) {
        if (!hasOrFilter($scope.workingConfig.filter)) {
          Utils.setIn($scope, ['workingConfig', 'filter', 'or'], [], {
            force: true
          });
        }
        //todo: don't assume order of or clauses
        if (!hasExcludedGroupIdsFilter($scope.workingConfig.filter)) {
          $scope.workingConfig.filter.or.unshift({
            excludeFromOutput: true
          });
        }
        $scope.workingConfig.filter.or[0].groupIds = groupIdsExcludedFromOutput;
      } else if (hasExcludedGroupIdsFilter($scope.workingConfig.filter)) {
        //remove the or filter if all the groups excluded from output are removed
        var _Utils$decons = Utils.decons(isExcludeGroupIdsFilter, $scope.workingConfig.filter.or),
          _Utils$decons2 = _slicedToArray(_Utils$decons, 2),
          restOfOrFilter = _Utils$decons2[1];
        Utils.setIn($scope, ['workingConfig', 'filter', 'or'], restOfOrFilter, {
          force: true
        });
        Utils.setIn($scope, ['workingConfig', 'filter', 'groupIds'], Utils.ifEmptyThenNull(groupIds), {
          force: true
        });
      } else {
        Utils.setIn($scope, ['workingConfig', 'filter', 'groupIds'], Utils.ifEmptyThenNull(groupIds), {
          force: true
        });
      }
      var groupTypes = _.filter(item, function (item) {
        return !item.personas && !item.peopleIds;
      });
      $scope.workingConfig.filter.groupTypeNames = Utils.ifEmptyThenNull(_.pluck(groupTypes, 'name'));
      $scope.updateCardWithWorkingConfig();
    }, true);
    var cleanupExcludedPeopleOrGroupWatch = $scope.$watchCollection('peoplePickerConfig.excludedPeopleOrGroups', function (item) {
      if (!$scope.showExplorer) {
        return;
      }

      // Drop any null items that might have snuck in
      item = item.filter(Boolean);

      // Map out personIds & customIds
      var people = item.filter(function (i) {
        return i.personas;
      });
      var personIds = people.filter(function (p) {
        return !p.customId;
      }).map(function (p) {
        return p.id;
      });
      var personCustomIds = people.filter(function (p) {
        return p.customId;
      }).map(function (p) {
        return p.customId;
      });

      // Map out groups, groupIds, and customGroupIds
      var groups = item.filter(function (i) {
        return i.peopleIds;
      });
      var groupIds = groups.filter(function (g) {
        return !g.customId;
      }).map(function (g) {
        return g.id;
      });
      var groupCustomIds = groups.filter(function (g) {
        return g.customId;
      }).map(function (g) {
        return g.customId;
      });

      // Map out group type names
      var groupTypes = item.filter(function (i) {
        return !i.personas && !i.peopleIds;
      }).map(function (g) {
        return g.name;
      });

      // Build the filter based on the maps above
      var filter = {
        personIds: Utils.ifEmptyThenNull(personIds),
        personCustomIds: Utils.ifEmptyThenNull(personCustomIds),
        groupIds: Utils.ifEmptyThenNull(groupIds),
        groupCustomIds: Utils.ifEmptyThenNull(groupCustomIds),
        groupTypeNames: Utils.ifEmptyThenNull(groupTypes)
      };

      // Init the NOT & NOT[OR] filters if they don't exist yet
      $scope.workingConfig.filter.not = $scope.workingConfig.filter.not || {};
      $scope.workingConfig.filter.not.or = $scope.workingConfig.filter.not.or || [];

      // Find the first NOT[OR] filter that has any of the above properties
      var i = _.findIndex($scope.workingConfig.filter.not.or, function (f) {
        var keys = Object.keys(f).join(', ');
        return keys.includes('personIds') || keys.includes('personCustomIds') || keys.includes('groupIds') || keys.includes('groupCustomIds') || keys.includes('groupTypeNames');
      });

      // If there's already a NOT[OR] filter replace it, otherwise, push it
      if (i > -1) {
        $scope.workingConfig.filter.not.or[i] = filter;
      } else {
        $scope.workingConfig.filter.not.or.push(filter);
      }

      // Clean up any filters that are empty or have all null values
      $scope.workingConfig.filter.not.or = cleanupEmptyOrNull($scope.workingConfig.filter.not.or);
      $scope.updateCardWithWorkingConfig();
    });
    $scope.$watch("workingConfig.filter.includeRelatedActivities", function () {
      if (!$scope.showExplorer) {
        return;
      }
      $scope.updateCardWithWorkingConfig();
    });
    $scope.$watch("workingConfig.includePeopleWithoutStatements", function () {
      if (!$scope.showExplorer) {
        return;
      }
      $scope.updateCardWithWorkingConfig();
    });
    $scope.$watch("workingConfig.hidePII", function (value) {
      if (!$scope.showExplorer) {
        return;
      }
      if (value !== true && value !== false) {
        $scope.workingConfig.hidePII = false;
      }
      $scope.updateCardWithWorkingConfig();
    });
    $scope.$watch("workingConfig.topResults", function () {
      if (!$scope.showExplorer) {
        return;
      }
      $scope.updateCardWithWorkingConfig();
    });
    $scope.$watch("peoplePickerConfig.excludeInactivePeople", function (item) {
      if (!$scope.showExplorer) {
        return;
      }
      $scope.workingConfig.filter.excludeInactivePeople = item;
      $scope.updateCardWithWorkingConfig();
    });
    $scope.$watch("peoplePickerConfig.intersectGroups", function (item) {
      if (!$scope.showExplorer) {
        return;
      }
      $scope.workingConfig.filter.intersectGroups = item;
      $scope.updateCardWithWorkingConfig();
    });
    $scope.$watch("peoplePickerConfig.intersectExcludedGroups", function (item) {
      if (!$scope.showExplorer) {
        return;
      }
      var excludedPeopleOrGroupsFilter = _.find($scope.workingConfig.filter.not && $scope.workingConfig.filter.not.or, function (f) {
        return f.personIds || f.personCustomIds || f.groupIds || f.groupCustomIds || f.groupTypeNames;
      });
      if (excludedPeopleOrGroupsFilter) {
        excludedPeopleOrGroupsFilter.intersectGroups = item;
      }
      $scope.updateCardWithWorkingConfig();
    });
    function setWorkingConfig(cardConfig) {
      $scope.workingConfig = angular.copy(cardConfig);
      $scope.workingConfig.filter = _.extend({}, emptyConfig.filter, cardConfig.filter);
    }
    function getWorkingConfig() {
      var cardConfig = angular.copy($scope.workingConfig),
        cardFilter = cardConfig.filter,
        dateFilter = cardFilter.dateFilter;
      if (dateFilter && dateFilter.dateType === 'none') {
        delete cardFilter.dateFilter;
      }
      if (cardFilter.activityIds === null) {
        delete cardFilter.activityIds;
      }
      if (cardFilter.groupIds === null) {
        delete cardFilter.groupIds;
      }
      if (cardFilter.groupCustomIds === null) {
        delete cardFilter.groupCustomIds;
      }
      if (cardFilter.personIds === null) {
        delete cardFilter.personIds;
      }
      if (cardFilter.personCustomIds === null) {
        delete cardFilter.personCustomIds;
      }

      // Common scenario where we have empty NOT filter -- Saving empty filters sometimes creates issues
      var emptyNotOrFilter = Utils._try(function () {
        return cardConfig.filter.not.or.length === 0 || false;
      }, false);
      var emptyNotOrFilterObject = Utils._try(function () {
        return Object.keys(cardConfig.filter.not.or[0]).length === 0 || false;
      }, false);
      if (emptyNotOrFilter || emptyNotOrFilterObject) {
        delete cardConfig.filter.not;
      }
      return cardConfig;
    }
    var populateSimpleModeScope = ExplorerUtils.populateSimpleModeScope;
    $scope.filtersAllowed = function () {
      return _.filter($scope.workingConfig.quickFilters, function (f) {
        return f;
      }).length;
    };

    // -------------------------------
    // Card Text
    // -------------------------------

    var emptyCardText = {
      title: null,
      summary: null,
      description: null
    };
    $scope.cardText = angular.copy(emptyCardText);
    $scope.textErrors = null;
    function setWorkingText(card) {
      $scope.cardText = {
        title: card.title,
        summary: card.summary,
        description: card.description
      };
    }
    function getWorkingText() {
      return $scope.cardText;
    }
    function setCardText(cardText) {
      var card = getCard();
      card.title = cardText.title;
      if (!card.title) {
        delete card.title;
      }
      card.summary = cardText.summary;
      if (!card.summary) {
        delete card.summary;
      }
      card.description = cardText.description;
      if (!card.description) {
        delete card.description;
      }
      setCard(card);
    }
    var cleanupCardTextWatch = $scope.$watchCollection('cardText', _.debounce($scope.$safeApply.bind($scope, function () {
      if (!$scope.showExplorer) {
        return;
      }
      setCardText(getWorkingText());
      $rootScope.$broadcast(wsEventNames.explorer.change.cardTitle, getWorkingText().title);
      $rootScope.$broadcast(wsEventNames.explorer.change.cardDescription, getWorkingText().description);
      $rootScope.$broadcast(wsEventNames.explorer.change.cardSummary, getWorkingText().summary);
    }), 500));
    function validateCard() {
      $scope.textErrors = Validation.validate({
        "title": {
          "rules": {
            "maxLength": 255,
            "required": true
          },
          "value": $scope.cardText.title
        },
        "summary": {
          "rules": {
            "maxLength": 255
          },
          "value": $scope.cardText.summary
        },
        "description": {
          "rules": {
            "maxLength": 4000
          },
          "value": $scope.cardText.description
        }
      });
      if ($scope.textErrors !== null) {
        $scope.openSection = "card-text";
        $location.hash('card-text-section');
        $anchorScroll();
        return false;
      }
      var cardValidation = ReportValidationService.validate('preview');
      if (cardValidation.hasErrors) {
        $scope.openSection = cardValidation.section;
        if (cardValidation.anchor) {
          $location.hash(cardValidation.anchor);
          $anchorScroll();
        }
        $scope.noDataMsg = cardValidation.message;
        return false;
      }
      return true;
    }
    $scope.cardTextHelpText = {
      helpTitle: 'Report Text',
      detailText: 'From the Report Text section, customize the text on the report. The Title is at the top of ' + 'the report on both the activity page and the report’s detail page. The Summary appears at the footer of ' + 'the report on the Activity page. The Description appears at the top of the report’s detail page under ' + ' the header.'
    };

    // -------------------------------
    // Session state
    // -------------------------------

    function prepareExplorer() {
      resetSessionState();
      GroupTypes.buildCache(); // Don't wait on this to resolve; just fire it off in background
      return $q.all([MeasureRegistry.prepareMeasures({
        _includeCategories: false
      }), ensureOrganizationState(), FilterRegistry.prepareFilters({
        includeFilterCategories: true
      })]);
    }
    function resetSessionState() {
      setCard(null);
      $scope.advancedError = null;
      $scope.showAdvancedEditor = false;
      $scope.dialog.show = false;
      if ($scope.activityPickerConfig.clearActivities) {
        $scope.activityPickerConfig.clearActivities();
      }
      if ($scope.peoplePickerConfig.clearPeopleAndGroups) {
        $scope.peoplePickerConfig.clearPeopleAndGroups();
      }
      $scope.dateFilter = angular.copy(emptyDateFilter);
      $scope.cardText = angular.copy(emptyCardText);
      $scope.customFilters = null;
      $scope.canEditCard = false;
      $scope.customConfigLocation = null;
      $scope.textErrors = null;
      $scope.openSection = null;
      $scope.previewInfo = null;
      $scope.userProvidedTitle = false;
      $scope.isDemoMode = Demo.isDemoMode();
    }
    var orgStatePromise = null,
      defaultTemplate = null;
    function ensureOrganizationState(forceRefresh) {
      if (orgStatePromise && !forceRefresh) {
        return orgStatePromise;
      }

      // Fetch earliest statement date
      $scope.earliestStatementDate = null;
      Interactions.get({
        size: 1,
        ascending: true
      }).then(function (results) {
        $scope.earliestStatementDate = results.length === 0 ? new Date() : Utils.parseISO8601DateTime(results[0].timestamp);
        return true;
      });

      // Only show 'exclude inactive people' checkbox if the org has inactives
      $scope.peoplePickerConfig.hasInactives = false;
      $http.get(Api.url("/inactive/has-inactives")).then(function (r) {
        $scope.peoplePickerConfig.hasInactives = r.data.hasInactives;
      });
      $scope.templates = [];
      defaultTemplate = null;

      // Templates and default template fetch
      var templatesPromise = CardTemplates.get().then(function (templates) {
        // Only capture explorable templates - hiddenTemplates is used during development of new templates
        // EXAMPLE: var hiddenTemplates = ['corr', 'lister-card'];
        var hiddenTemplates = ['range-chart', 'network', 'wordcloud', 'status'];
        $scope.templates = _.filter(templates.results, function (template) {
          return template.explorable && (!_.contains(hiddenTemplates, template.name) || UserRoles.isWatershedEmployee(User.get()));
        });
        var BASIC_CARDS = ["bar", "heatmap", "line", "range", "scatter", "spider", "leaderboard"];
        var ADVANCED_CARDS = ["correlation"];
        var PROGRAM_CARDS = ["program"];
        var unauthorizedTemplates = [];
        if (!Demo.isDemoMode()) {
          if (!OrganizationSettings.hasFeature("basicExplorer")) {
            unauthorizedTemplates = unauthorizedTemplates.concat(BASIC_CARDS);
          }
          if (!OrganizationSettings.hasFeature("advancedExplorer")) {
            unauthorizedTemplates = unauthorizedTemplates.concat(ADVANCED_CARDS);
          }
          if (!OrganizationSettings.hasFeature("programs")) {
            unauthorizedTemplates = unauthorizedTemplates.concat(PROGRAM_CARDS);
          }
        }

        // Now filter out unauthorized templates
        $scope.templates = _.filter($scope.templates, function (template) {
          return !_.contains(unauthorizedTemplates, template.name);
        });

        // Capture interactions as the default template
        defaultTemplate = _.find($scope.templates, function (template) {
          return template.name === wsConstants.interactionsTemplateName;
        });
      });

      // "Pick from all" state reset
      var hasGroupsPromise = $scope.peoplePickerConfig.ensureOrganizationState();
      orgStatePromise = $q.all([templatesPromise, hasGroupsPromise]);
      return orgStatePromise;
    }
    $scope.hasExplorerPermissions = false;
    var ensureExplorePermissions = function ensureExplorePermissions() {
      AppPermissions.getForUser({
        value: 'explorer'
      }).then(function (permissions) {
        $scope.hasExplorerPermissions = (permissions.length || UserRoles.isExploreAllowed(User.get())) && !UserRoles.isConsultant(User.get()) && !ViewDashboardsAs.isActive;
      });
    };
    ensureExplorePermissions();
    $rootScope.$on('organization-selected', ensureExplorePermissions);

    // -------------------------------
    // Explore action (entry to explorer)
    // -------------------------------

    var cleanupExploreCard = $rootScope.$on('explore-card', function (evt, cfg) {
      cfg = cfg || {};
      var cardId = cfg.cardId;
      $scope.cardId = cfg.cardId;
      if (!$scope.hasExplorerPermissions) {
        return;
      }
      $scope.advancedConfigUsed = false;
      $scope.externalConnection = false;

      //entry into explorer using the back button or browser history in any way
      $scope.locationChangeEntry = cfg.locationChangeEntry || false;
      $scope.originalLocation = $location.url();
      prepareExplorer().then(function () {
        $scope.isNewCard = !cardId;
        if ($scope.isNewCard) {
          $rootScope.$broadcast("nav:change", "explore");
        }

        // If no cardId was supplied, this is a new card
        var card;
        if (cardId) {
          card = angular.copy(CardRegistry.get(cardId));
          $http.get(Api.url("/shares/by-card-id/" + cardId, true)).then(function (r) {
            $scope.externalConnection = _.any(r.data.results, function (s) {
              return s.externalConnection;
            });
          });
        } else {
          card = {
            title: "New Interactions",
            template: defaultTemplate,
            configuration: {
              quickFilters: {
                people: {
                  type: 'all'
                },
                verbs: {
                  type: 'all'
                },
                activities: {
                  type: 'all'
                },
                dates: {
                  type: 'all'
                }
              }
            },
            organization: User.get().organization

            // TODO: Select proper card group -- currently will default to the one
            // specified in the card template. But we may want it to be "Your Reports"
            // if this is a non-admin user.
          };
          $scope.extendedHelpText = defaultTemplate.description;
          $scope.extendedHelpLabel = defaultTemplate.title;
        }
        if (cardId) {
          //if this is NOT a new card don't change the title
          $scope.userProvidedTitle = true;
          $scope.userProvidedTitle = true;
          $scope.userProvidedTitle = true;
        }
        $scope.originalCard = card;
        delete $scope.showExplorer;
        exploreCard(card);
        if (cfg.advanced) {
          $scope.showAdvanced();
        }
      });
    });
    function exploreCard(card) {
      // Cancel outstanding card requests, to keep explorer snappy
      CardQueryResource.cancelAllOutstanding();

      //Object so it can be set in child scopes. Clears every time things are re-setup.
      $scope.hide = {};
      $scope.require = {};
      $scope.peoplePickerConfig.personPicker = {};
      $scope.customConfig = {};
      $scope.isNewCard = !card.id;
      $scope.pickerConfig.dialog = $scope.dialog;
      $scope.cardChangeHandlers = [];

      // Determine, based on this card, if the user can edit this card
      determineCanEditStatus(card).then(function (result) {
        $scope.canEditCard = result;
      });

      // Find this card's template from our list, or else it's the default template
      $scope.selectedTemplate = _.findWhere($scope.templates, {
        id: card.template.id
      }) || defaultTemplate;

      // Initialize the configuration we'll use in the explorer
      var filter = _.extend({}, emptyConfig.filter, card.configuration.filter),
        quickFilters = _.extend({}, emptyConfig.quickFilters, card.configuration.quickFilters);

      // Setup some explorer state for this card
      setWorkingText(card);
      FilterRegistry.setCustomFiltersOnCard(card);
      var config = _.extend({}, card.configuration, {
        filter: filter,
        quickFilters: quickFilters
      });
      setWorkingConfig(config);
      //have to make a copy of the workingConfig because of watch initializations that alter this variable
      populateSimpleModeScope($scope.workingConfig.filter, explorerUtilsCfg);
      setupCustomConfig(card.template);
      $scope.$watch("peoplePickerConfig.selectedPeopleOrGroups", function (val) {
        // If we only want a single person, use the second person (one that was just added)
        if ($scope.peoplePickerConfig.personPicker.singlePerson && val.length > 1) {
          $scope.peoplePickerConfig.selectedPeopleOrGroups = $scope.peoplePickerConfig.selectedPeopleOrGroups.splice(1, 1);
        }
      }, true);
      setCard(card);
      setCardConfig(getWorkingConfig());

      // Load this card's preview card and detail page
      lastCardPreviewed = null;
      reloadPreview();

      // Capture initial snapshot of config output from explorer, for comparison
      // later to know if changes have been made...
      $scope.originalConfig = getWorkingConfig();
      $scope.originalTitle = angular.copy($scope.cardText.title);

      // Scroll the user to top of window and make sure the selected template is shown
      // in the carousel.
      window.scrollTo(0, 0);
      moveCarouselToSelectedTemplate();

      // Person page is a special case, since it only has one expose section let's be friendly
      // and expand it on entry.
      if (card.template.name === 'person') {
        $scope.openSection = 'people';
      } else {
        $scope.openSection = null;
      }
    }
    function determineCanEditStatus(card) {
      if ($scope.userIsAdmin() || _.isEmpty(card.cardGroupIds)) {
        var deferred = $q.defer();
        deferred.resolve(true);
        return deferred.promise;
      }
      var cardGroupPromises = _.map(card.cardGroupIds, function (id) {
        return CardGroup.get(id);
      });
      return $q.all(cardGroupPromises).then(function (responses) {
        var users = _.chain(responses).pluck("user").compact().value();
        return !_.isEmpty(users);
      });
    }

    // -------------------------------
    // Initialization / Other Events
    // -------------------------------

    // If they've refreshed on a preview page, just send em back to the default route
    if ($location.path().indexOf("/preview") >= 0) {
      setCard(null);
      $location.url("/");
    }

    // When organization changes, re-init
    var cleanupOrganizationWatch = $rootScope.$on('organization-selected', function () {
      ensureOrganizationState(true);
    });

    // If they click away, auto cancel explorer (which prompts them about unsaved changes)
    //NOTE: this won't work if they click away by clicking on the Explore button
    var cleanupChangeStartWatch = $scope.$on('$locationChangeStart', function (event, next) {
      if (next.indexOf("/preview") === -1 && $scope.showExplorer) {
        $scope.cancel(true, event);
      }
    });
    var cleanupViewDashboardsAsWatch = $scope.$on(wsEventNames.viewDashboardsAs.active, function (evt, state) {
      if (state === true && $location.path().indexOf("/preview") >= 0) {
        $location.url("/");
      }
    });
    var cleanupChangeSuccessWatch = $scope.$on('$locationChangeSuccess', function (event, next, previous) {
      $scope.showExplorer = next.indexOf("/preview") !== -1;
      ExplorerUtils.setIsVisible($scope.showExplorer);
      if ($scope.locationChangeEntry !== false && $scope.showExplorer && previous.indexOf("/preview") === -1) {
        $rootScope.$broadcast("explore-card", {
          locationChangeEntry: true,
          cardId: $scope.cardId
        });
      }
      delete $scope.locationChangeEntry;
    });
    $scope.$on('$destroy', function () {
      cleanupNavWatch();
      cleanupDialogWatch();
      cleanupDateFilterWatch();
      cleanupActivitiesWatch();
      cleanupExcludedActivitiesWatch();
      cleanupVerbsWatch();
      cleanupExcludedVerbsWatch();
      cleanupPeopleOrGroupsWatch();
      cleanupExcludedPeopleOrGroupWatch();
      cleanupCardTextWatch();
      cleanupExploreCard();
      cleanupOrganizationWatch();
      cleanupChangeStartWatch();
      cleanupViewDashboardsAsWatch();
      cleanupChangeSuccessWatch();
      cleanupBadgeWatch();
    });
  }]);
})(this);
